import React from 'react'
import {
  IconCheck,
  IconMessageFilled,
  IconPlayerPlayFilled,
  IconPlayerStopFilled,
  IconX,
} from '@tabler/icons-react'
import './InteractionOverlay.css'

const ICONS = {
  'stop-listen': <IconPlayerStopFilled size={14} className="alert-icon fill-critical" />,
  chat: <IconMessageFilled size={14} className="alert-icon fill-informative" />,
  check: <IconCheck size={14} className="alert-icon status-brand" />,
  'start-listen': <IconPlayerPlayFilled size={14} className="alert-icon fill-success" />,
  close: <IconX size={14} className="alert-icon" />,
}

export const InteractionOverlay = ({ type, style }) => {
  let className = 'interaction-outer-box'
  if (type === 'check' || type === 'close') {
    className += ' circle-outer-box'
  }

  return (
    <div className={className} data-testid="interaction-overlay" style={{ ...style }}>
      <div data-testid={type}>{ICONS[type]}</div>
    </div>
  )
}
